<template>
    <div class="pa-0 ma-0">

        <v-row v-if="title">
            <v-col cols="10">
                <h3> &nbsp; {{title}} </h3> 
            </v-col>
        </v-row>

        <v-row class="row mb-2">
            <v-col cols="9" md="7" :class="{ 'px-2': is_mobile, 'py-0': true }">
                <label v-if="actual_party.type == 'fisica'" class="input-label label-base">Nombre y apellidos</label>
                <label v-else class="input-label label-base">Razón social</label>
                <template v-if="!emisor" >
                    <PartyAutocomplete
                        v-if="!readonly"
                        v-model="customer"
                        :readonly="readonly"
                        :invoiceable-repo="invoiceable_repo"
                        :company-id="company_id"
                        :party-options="partyOptions"
                        :error="showErrors && isParyIncoplete(actual_party)"
                        :background-color="showErrors && isParyIncoplete(actual_party) ? '#DC0B0B1A' : 'white'"
                        @change="autocompleteEmit"
                    />
                    <AppTextFieldV2
                        v-else
                        :value="actual_party.type == 'fisica' ? `${actual_party.first_surname} ${actual_party.second_surname}, ${actual_party.name}`: actual_party.business_name"
                        :readonly="true"
                        :error="showErrors && isParyIncoplete(actual_party)"
                        :background_color="showErrors && isParyIncoplete(actual_party) ? '#DC0B0B1A' : 'white'"
                    />
                </template>
                <AppTextFieldV2
                    v-else
                    :value="actual_party.type == 'fisica' ? `${actual_party.first_surname} ${actual_party.second_surname}, ${actual_party.name}`: actual_party.business_name"
                    :readonly="true"
                    :error="showErrors && isParyIncoplete(actual_party)"
                    :background_color="showErrors && isParyIncoplete(actual_party) ? '#DC0B0B1A': ''"
                />
            </v-col>
            <v-col 
                cols="1" 
                lg="4"
                md="5"
                :class="{
                    'px-1': is_mobile, 
                    'py-0': true,
                    'd-flex': true,
                    'flex-column-reverse': true
                }">
                <v-btn
                    class="edit__btn elevation-0"
                    color="transparent"
                    height="40px"
                    @click="openPartyEditor"
                >
                    <v-icon 
                        color="primary" 
                        :left="!is_mobile" 
                        class="material-symbols-outlined"
                    >edit_square</v-icon>
                    <span 
                        v-if="emisor && !is_mobile"
                    >Editar emisor</span>
                    <span 
                        v-else-if="!is_mobile"
                    >Editar receptor</span>
                </v-btn>
            </v-col>
        </v-row>
        
        <v-row class="label-cif">
            <v-col cols="7" md="5" lg="4" :class="{ 'px-2': is_mobile, 'py-0': true }">
                <AppTextFieldV2
                    class="mr-1 label-base"
                    label="CIF"
                    v-model="actual_party.cif"
                    :readonly="true"
                    :error="showErrors && (['', null, undefined].includes(actual_party.cif) || (actual_party.cif && /[^a-zA-Z0-9]/.test(actual_party.cif)))"
                    :background_color="showErrors && (['', null, undefined].includes(actual_party.cif) || (actual_party.cif && /[^a-zA-Z0-9]/.test(actual_party.cif))) ? '#DC0B0B1A' : 'white'"
                    @input="validateCIF"
                />
            </v-col>

            <ViesValidator :third="actual_party" v-if="!emisor"/>
       
        </v-row>



        <div style="padding: 0px 10px;">
            <v-dialog v-model="showPartyEditor" class="pa-0 ma-0 rounded-lg" persistent max-width="1000px" overlay-color="primary_blue" :key="partyKey">
                <v-card>
                    <v-card-title class="party__editor__title">
                      <span v-if="emisor">Emisor</span>
                      <span v-else>Receptor</span>
                      <v-spacer v-if="is_mobile"/>
                      <button v-if="is_mobile" @click="showPartyEditor = false">
                        <v-icon>mdi-close</v-icon>
                      </button>

                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row :class="{ 'mx-8': !is_mobile, 'mt-8': !is_mobile, 'mb-0': !is_mobile }">
                            <v-col cols="12" md="5" sm="5">
                                <label v-if="actual_party.type == 'fisica'">Nombre y apellidos</label>
                                <label v-else>Razón social</label>
                                <template v-if="!emisor">
                                    <PartyAutocomplete
                                        v-if="!readonly"
                                        v-model="customer"
                                        :readonly="readonly"
                                        :invoiceable-repo="invoiceable_repo"
                                        :company-id="company_id"
                                        :party-options="partyOptions"
                                        :error="showErrors && isParyIncoplete(actual_party)"
                                        :background-color="showErrors && isParyIncoplete(actual_party) ? '#DC0B0B1A' : 'white'"
                                        @change="autocompleteEmit"
                                    />
                                    <AppTextFieldV2
                                        v-else
                                        :value="actual_party.type == 'fisica' ? `${actual_party.first_surname} ${actual_party.second_surname}, ${actual_party.name}`: actual_party.business_name"
                                        :readonly="true"
                                        :error="showErrors && isParyIncoplete(actual_party)"
                                        :background_color="showErrors && isParyIncoplete(actual_party) ? '#DC0B0B1A' : 'white'"
                                    />
                                </template>
                                <!-- :readonly="true" -->
                                <AppTextFieldV2
                                    v-if="emisor"
                                    :value="actual_party.type == 'fisica' ? `${actual_party.first_surname} ${actual_party.second_surname}, ${actual_party.name}`: actual_party.business_name"
                                    :error="showErrors && isParyIncoplete(actual_party)"
                                    :background_color="showErrors && isParyIncoplete(actual_party) ? '#DC0B0B1A': ''"
                                />
                            </v-col>
                            <v-col cols="12" md="3" sm="3">
                                <label>Tipo</label>
                                <v-select
                                    v-model="actual_party.type"
                                    :items="type_options"
                                    :readonly="readonly"
                                    class="pt-0 mt-0"
                                    hide-details
                                    flat
                                    outlined
                                    dense
                                    @change="typeChanged"
                                    :error="showErrors && ['', null, undefined].includes(actual_party.type)"
                                    :background_color="showErrors && ['', null, undefined].includes(actual_party.type) ? '#DC0B0B1A' : 'white'"
                                />
                            </v-col>
                            <v-col cols="12" md="4" sm="4">
                                <label>CIF</label>
                                <div class="d-flex align-center">
                                    <AppTextFieldV2
                                        class="mr-1"
                                        v-model="actual_party.cif"
                                        :readonly="readonly"
                                        :error="showErrors && (['', null, undefined].includes(actual_party.cif) || (actual_party.cif && /[^a-zA-Z0-9]/.test(actual_party.cif)))"
                                        :background_color="showErrors && (['', null, undefined].includes(actual_party.cif) || (actual_party.cif && /[^a-zA-Z0-9]/.test(actual_party.cif))) ? '#DC0B0B1A' : 'white'"
                                        @input="validateCIF"
                                    />
                                </div>
                            </v-col>
                        </v-row>
                        <p v-if="false && emisor && isParyIncoplete(actual_party) && allow_refresh" class="red--text py-0 my-0 text-caption"> Es necesario completar los datos del emisor. Estos datos se pueden completar desde la ficha de la empresa</p>
                        
                        <v-tabs
                            v-model="activeTab"
                            class="card__tabs"
                        >
                            <v-tab class="text-capitalize">Básicos</v-tab>
                            <v-tab v-if="tabContains('bank_info')" class="text-capitalize">Información bancaria</v-tab>
                            <v-tab v-if="actual_party.type == 'juridica' && !emisor && tabContains('dir3')">DIR3</v-tab>
                            <v-tab v-if="!emisor && tabContains('advanced_config') && got_feature('feature_pdf_language')" class="text-capitalize">Configuración Avanzada</v-tab>
                            <v-tab v-if="emisor && tabContains('datos_representacion')" class="text-capitalize">Datos de representación</v-tab>
                            <v-tab v-if="emisor && tabContains('configuracion_rrsif') && showRRSIFTab" class="text-capitalize">Configuración RRSIF</v-tab>
                        </v-tabs>
                        <v-divider></v-divider>
                        <v-tabs-items v-model="activeTab" :key="tabsKey">
                            <!-- <v-tab-item v-for="tab in tabs" :key="tab.code"> -->
                                <v-tab-item :class="{ 'mx-14': !is_mobile, 'mt-6': !is_mobile, 'px-14': !is_mobile }">
                                    <v-row v-if="actual_party.type == 'juridica'">
                                        <v-col cols="12" md="6" class="py-1">
                                            <label>Razón social</label>
                                            <AppTextFieldV2
                                                kind="text"
                                                v-model="actual_party.business_name"
                                                :readonly="readonly"
                                                :error="showErrors && actual_party.type=='juridica' && ['', null, undefined].includes(actual_party.business_name)"
                                                :background_color="showErrors && actual_party.type=='juridica' && ['', null, undefined].includes(actual_party.business_name) ? '#DC0B0B1A' : 'white'"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <label>Nombre comercial</label>
                                            <AppTextFieldV2
                                                kind="text"
                                                v-model="tradeNameModel"
                                                :readonly="isTradeNameReadonly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="actual_party.type == 'fisica'">
                                        <v-col cols="12" md="4" class="py-1">
                                            <label>Nombre</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.name"
                                                :readonly="readonly"
                                                :error="showErrors && actual_party.type=='fisica' && ['', null, undefined].includes(actual_party.name)"
                                                :background_color="showErrors && actual_party.type=='fisica' && ['', null, undefined].includes(actual_party.name) ? '#DC0B0B1A' : 'white'"
                                            />
                                        </v-col>
                                        <v-col cols="6" md="4" class="py-1">
                                            <label>Primer apellido</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.first_surname"
                                                :readonly="readonly"
                                                :error="showErrors && actual_party.type=='fisica' && ['', null, undefined].includes(actual_party.first_surname)"
                                                :background_color="showErrors && actual_party.type=='fisica' && ['', null, undefined].includes(actual_party.first_surname) ? '#DC0B0B1A' : 'white'"
                                            />
                                        </v-col>
                                        <v-col cols="6" md="4" class="py-1">
                                            <label>Segundo apellido</label>
                                            <AppTextFieldV2
                                                kind="text"
                                                v-model="actual_party.second_surname"
                                                :readonly="readonly"
                                                />
                                                <!-- :error="showErrors && party.type=='fisica' && ['', null, undefined].includes(party.second_surname)"
                                                :background-color="showErrors && party.type=='fisica' && ['', null, undefined].includes(party.second_surname) ? '#DC0B0B1A' : 'white'" -->
                                        </v-col>
                                    </v-row>
                                    <!-- <v-row v-if="emisor">
                                        <v-col cols="6" class="py-1">
                                            <label>IBAN</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.bank_account_number"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="6" class="py-1">
                                            <label>BIC</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.bic"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                    </v-row> -->
                                    <v-row>
                                        <v-col cols="emisor ? 12 : 8" class="py-1">
                                            <label>Dirección</label>
                                            <AppTextFieldV2
                                                kind="text"
                                                v-model="actual_party.address"
                                                :readonly="readonly"
                                                :error="showErrors && ['', null, undefined].includes(actual_party.address)"
                                                :background_color="showErrors && ['', null, undefined].includes(actual_party.address) ? '#DC0B0B1A' : 'white'"
                                            />
                                        </v-col>
                                        <v-col :cols="emisor ? 0 : 4" class="py-1" v-if="!emisor">
                                            <label>País</label>
                                            <v-select
                                                v-model="actual_party.country"
                                                :items="country_options"
                                                item-text="text"
                                                item-value="value"
                                                :readonly="readonly"
                                                class="pt-0 mt-0"
                                                hide-details
                                                flat
                                                outlined
                                                dense
                                                clearable
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6" md="4" class="py-1">
                                            <label>Localidad</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.city"
                                                :readonly="readonly"
                                                :error="showErrors && ['', null, undefined].includes(actual_party.city)"
                                                :background_color="showErrors && ['', null, undefined].includes(actual_party.city) ? '#DC0B0B1A' : 'white'"
                                            />
                                        </v-col>
                                        <v-col cols="6" md="4" class="py-1">
                                            <label>Provincia</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.province"
                                                :readonly="readonly"
                                                :error="showErrors && ['', null, undefined].includes(actual_party.province)"
                                                :background_color="showErrors && ['', null, undefined].includes(actual_party.province) ? '#DC0B0B1A' : 'white'"
                                            />
                                        </v-col>
                                        <v-col cols="6" md="4" class="py-1">
                                            <label>Código postal</label>
                                            <AppTextFieldV2
                                                kind="text"
                                                v-model="actual_party.post_code"
                                                :readonly="readonly"
                                                :error="showErrors && ['', null, undefined].includes(actual_party.post_code)"
                                                :background_color="showErrors && ['', null, undefined].includes(actual_party.post_code) ? '#DC0B0B1A' : 'white'"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col :cols="emisor? '4': '6'" class="py-1">
                                            <label>Correo electrónico</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.email"
                                            />
                                        </v-col>
                                        <v-col :cols="emisor? '4': '6'" class="py-1">
                                            <label>Teléfono</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.phone"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col v-if="emisor" cols="4" class="py-1">
                                            <label>Página web</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.website"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                                <v-tab-item  :class="{ 'mx-14': !is_mobile, 'mt-6': !is_mobile, 'px-14': !is_mobile }">
                                    <v-row>
                                        <v-col cols="6" class="py-1">
                                            <label>IBAN</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.bank_account_number"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="6" class="py-1">
                                            <label>BIC</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.bic"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6" class="py-1">
                                            <label>ID mandato SEPA</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.mandate_id"
                                            />
                                                <!-- :readonly="readonly" -->
                                        </v-col>
                                        <v-col cols="6" class="py-1" v-if="!emisor">
                                            <AppDateField
                                                ref="invoiceStartDate"
                                                label="Fecha firma mandato SEPA"
                                                v-model="actual_party.mandate_signature_date"
                                                clearable
                                            />
                                                <!-- :disabled="readonly" -->
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="!emisor">
                                        <v-col cols="6">
                                            <label>Método de pago</label>
                                            <v-select
                                                v-model="actual_party.payment_means"
                                                :items="payment_means_options"
                                                :readonly="readonly"
                                                class="pt-0 mt-0"
                                                hide-details
                                                flat
                                                outlined
                                                dense
                                            />
                                        </v-col>
                                        <v-col cols="6">
                                            <label>Información de pago</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.payment_information"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                                <v-tab-item v-if="actual_party.type == 'juridica' && !emisor" :class="{ 'mx-14': !is_mobile, 'mt-6': !is_mobile, 'px-14': !is_mobile }">
                                    <v-row>
                                        <v-col cols="12" class="py-1">
                                            <label>Unidad Tramitadora</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.processing_unit"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6" class="py-1">
                                            <label>Oficina Contable</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.accounting_office"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="6" class="py-1">
                                            <label>Órgano Proponente</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.proposing_body"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6" class="py-1">
                                            <label>DIRe</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.DIRe"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="6" class="py-1">
                                            <label>Órgano Gestor</label>
                                            <AppTextFieldV2
                                                v-model="actual_party.management_body"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                                <v-tab-item v-if="emisor" :class="{ 'mx-14': !is_mobile, 'mt-6': !is_mobile, 'px-14': !is_mobile }">
                                    <v-row v-if="emisor">
                                        <v-col cols="12" md="6" class="py-1">
                                            <div class="d-flex align-center justify-space-between">
                                                <label style="font-size: 15px; font-weight: 600; margin: 0; color: var(--v-primary_blue-base);">Modelo</label>
                                                <div class="d-flex align-center">
                                                <input
                                                    type="file"
                                                    ref="fileInputPDF"
                                                    style="display: none"
                                                    accept="application/pdf"
                                                    @change="handleFileUpload($event, 'pdf')"
                                                />
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <AppIcon :src="require('../assets/view_doc_purple.svg')" :size="29" style="cursor: pointer; width: 28px; height: 28px;" @click="downloadUploatedRepresentationForm()" />
                                                    </template>
                                                    <span>Descargar formulario de representación subido previamente</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            @click="openFileExplorerPDF()"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :loading="uploadingFile"
                                                            class="button-nou mx-1"
                                                        >
                                                            <v-icon left size="25" class="material-symbols-outlined">upload_file</v-icon>
                                                            Subir
                                                        </v-btn>
                                                    </template>
                                                    <span>Subir formulario de representación</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            @click="checkDownloadRepresentationForm()"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :loading="downloadingForm"
                                                            class="button-nou mx-1"
                                                        >
                                                            Descargar
                                                        </v-btn>
                                                    </template>
                                                    <span>Descargar formulario de representación</span>
                                                </v-tooltip>
                                                </div>
                                            </div>
                                            <v-col cols="12" v-if="uploadedPdfFileName" class="pt-3 pb-0">
                                                <p class="text-caption grey--text mb-0 text-right d-flex align-center justify-end" style="font-size: 11px;">
                                                    <v-icon small color="success" class="mr-1">mdi-check-circle</v-icon>
                                                    Modelo subido con éxito
                                                </p>
                                            </v-col>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <div class="d-flex align-center justify-space-between">
                                                <label style="font-size: 15px; font-weight: 600; margin: 0; color: var(--v-primary_blue-base);">Documento DNI</label>
                                                <div class="d-flex align-center">
                                                <input
                                                    type="file"
                                                    ref="fileInputDNI"
                                                    style="display: none"
                                                    accept="application/pdf,image/jpeg,image/png,image/gif,image/bmp,image/webp"
                                                    @change="handleFileUpload($event, 'dni')"
                                                />
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <AppIcon :src="require('../assets/view_doc_purple.svg')" :size="29" style="cursor: pointer; width: 28px; height: 28px; margin-right: 4px;" @click="downloadUploatedDni()" />
                                                    </template>
                                                    <span>Descargar DNI subido previamente</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            @click="openFileExplorerDNI()"
                                                            :loading="uploadingFile"
                                                            v-bind="attrs" v-on="on"
                                                            class="button-nou mx-1"
                                                        >
                                                            <v-icon left size="25" class="material-symbols-outlined">upload_file</v-icon>
                                                            Subir
                                                        </v-btn>
                                                    </template>
                                                    <span>Subir DNI</span>
                                                </v-tooltip>
                                                </div>
                                            </div>
                                            <v-col cols="12" v-if="uploadedDniFileName" class="pt-3 pb-0">
                                                <p class="text-caption grey--text mb-0 text-right d-flex align-center justify-end" style="font-size: 11px;">
                                                    <v-icon small color="success" class="mr-1">mdi-check-circle</v-icon>
                                                    Documento DNI subido con éxito
                                                </p>
                                            </v-col>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="6" class="py-1">
                                            <label>Nombre representante</label>
                                            <v-text-field
                                                v-if="actual_party.type !== 'fisica'"
                                                v-model="actual_party.representation_data.client_name"
                                                outlined
                                                dense
                                                hide-details
                                                placeholder="Ingrese el nombre del cliente"
                                            />
                                            <AppTextFieldV2
                                                v-else
                                                :value="representativeFullName"
                                                :readonly="true"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <label>NIF representante</label>
                                            <v-text-field
                                                v-if="actual_party.type !== 'fisica'"
                                                v-model="actual_party.representation_data.client_nif"
                                                outlined
                                                dense
                                                hide-details
                                                placeholder="Ingrese el NIF"
                                            />
                                            <AppTextFieldV2
                                                v-else
                                                :value="representativeNif"
                                                :readonly="true"
                                            />
                                        </v-col>
                                        <v-col cols="12" class="py-1 mt-4">
                                            <label class="font-weight-bold" style="color: var(--v-primary_blue-base); font-size: 15px; font-weight: 600; margin: 0;">Domicilio fiscal</label>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <label>Vía pública</label>
                                            <v-text-field
                                                v-if="actual_party.type !== 'fisica'"
                                                v-model="actual_party.representation_data.street"
                                                outlined
                                                dense
                                                hide-details
                                                placeholder="Ingrese la vía pública"
                                            />
                                            <AppTextFieldV2
                                                v-else
                                                :value="representativeStreet"
                                                :readonly="true"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="4" class="py-1">
                                            <label>Municipio</label>
                                            <v-text-field
                                                v-if="actual_party.type !== 'fisica'"
                                                v-model="actual_party.representation_data.municipality"
                                                outlined
                                                dense
                                                hide-details
                                                placeholder="Ingrese el municipio"
                                            />
                                            <AppTextFieldV2
                                                v-else
                                                :value="representativeMunicipality"
                                                :readonly="true"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="2" class="py-1">
                                            <label>Número</label>
                                            <v-text-field
                                                v-model="actual_party.representation_data.number"
                                                outlined
                                                dense
                                                hide-details
                                                placeholder="Nº"
                                                :readonly="ifPersonaFisicaReadOnly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" class="py-1 d-flex align-center">
                                            <v-checkbox
                                                v-if="im_staff_or_login_as"
                                                v-model="validateDNI"
                                                label="Validar DNI"
                                                class="mr-4"
                                                hide-details
                                            ></v-checkbox>

                                            <v-checkbox
                                                v-if="im_staff_or_login_as"
                                                v-model="validatePDF"
                                                label="Validar PDF"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                                <v-tab-item v-if="emisor && showRRSIFTab" :class="{ 'mx-14': !is_mobile, 'mt-6': !is_mobile, 'px-14': !is_mobile }">
                                    <div>
                                        <h3 style="font-family: Roboto, sans-serif; font-size: 15px; font-weight: 400; color: #6A6A6B;">Selecciona el uso que vas hacer del software de facturación en esta empresa:</h3>
                                    </div>
                                    <v-row class="mt-4">
                                        <v-col cols="12" class="py-2">
                                            <div class="d-inline-flex align-center" style="gap:40px; min-height:48px;">
                                                <v-checkbox
                                                    v-model="rrsif_config['auto_send_to_verifactu']"
                                                    :disabled="checkboxDisabled"
                                                    @click="onlyOneSelectedRRSIFOption('auto_send_to_verifactu')"
                                                    class="mt-0 mb-0"
                                                    hide-details
                                                    style="flex:0 0 auto;"
                                                >
                                                    <template slot="label">
                                                        <span>
                                                            Envío automático de factura a Verifactu. Fecha de activación:
                                                            <span v-if="activationDate">{{ activationDate }}</span>
                                                        </span>
                                                    </template>
                                                </v-checkbox>

                                                <app-select
                                                    v-if="im_staff_or_login_as"
                                                    v-model="verifactu_provider"
                                                    :items="verifactu_providers"
                                                    label="Remitente de Verifactu"
                                                    item-text="label"
                                                    item-value="value"
                                                    class="verifactu-select"
                                                ></app-select>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" class="py-2">
                                            <v-checkbox
                                                v-model="rrsif_config['sii_opt_checked']"
                                                :disabled="checkboxDisabled"
                                                @click="onlyOneSelectedRRSIFOption('sii_opt_checked')"
                                                label="Acogido al SII"
                                                class="mt-0 mb-0"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" class="py-2">
                                            <v-checkbox
                                                v-model="rrsif_config['spanish_territory_opt_checked']"
                                                :disabled="checkboxDisabled"
                                                @click="onlyOneSelectedRRSIFOption('spanish_territory_opt_checked')"
                                                label="Empresa situada fuera del territorio español"
                                                class="mt-0 mb-0"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" class="py-2">
                                            <div class="d-flex align-center">
                                                <v-checkbox
                                                    v-model="rrsif_config['no_application_checked']"
                                                    :disabled="checkboxDisabled"
                                                    label="Solicitud de No aplicación. Art 5 RD"
                                                    @click="onlyOneSelectedRRSIFOption('no_application_checked')"
                                                    class="mt-0 mb-0"
                                                    hide-details
                                                    style="flex: 0 0 auto;"
                                                ></v-checkbox>

                                                <label style="margin-left: 40px; flex: 0 0 auto;">
                                                    Identificación del acuerdo (resolución):
                                                </label>

                                                <v-text-field
                                                    v-model="rrsif_config['requestNoApplicationTextBox']"
                                                    :disabled="textboxDisabled"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    style="max-width: 300px; margin-left: 10px"
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-4">
                                        <v-col cols="12">
                                            <div class="d-flex" style="gap: 16px; align-items: center;">
                                                <h3 style="font-family: Roboto, sans-serif; font-size: 12px; font-weight: 400; color: #A4A4A6; margin: 0; line-height: 1; display: flex; align-items: center;">
                                                    Confirmo que el motivo por el que no aplico el Reglamento de Sistemas Informáticos de Facturación es verídico:
                                                </h3>
                                                <v-switch
                                                    v-model="rrsif_config['switch_verification']"
                                                    :disabled="switchDisabled"
                                                    color="var(--v-primary-base)"
                                                    inset
                                                    hide-details
                                                    class="mt-0"
                                                    style="flex-shrink: 0; margin-top: -2px;"
                                                />
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                                <v-tab-item v-if="!emisor" :class="{ 'mx-14': !is_mobile, 'mt-6': !is_mobile, 'px-14': !is_mobile }">
                                    <v-row>
                                        <v-col cols="12" md="6" class="py-1">
                                            <label>Idioma del PDF</label>
                                            <v-select
                                                v-model="actual_party.pdf_language"
                                                :items="language_options"
                                                :readonly="readonly"
                                                class="pt-0 mt-0"
                                                hide-details
                                                flat
                                                outlined
                                                dense
                                            />
                                        </v-col>
                                    </v-row>
                                </v-tab-item>

                            <!-- </v-tab-item> -->
                        </v-tabs-items> 

                    </v-card-text>
                    <v-card-actions 
                        class=""
                        :class="{
                            'justify-center': true,
                            'px-8': !is_mobile, 
                            'mx-8': true, 
                            'pb-8': true,
                        }"
                    >
                        <v-btn outlined @click="cancelSave()" class="action__btn" v-if="!companyEditor">
                            <span v-if="emisor || readonly">Cerrar</span>
                            <span v-else>Cancelar</span>
                        </v-btn>
                        <v-btn v-else outlined @click="companyEditorClose()" class="action__btn">
                            <span>Cerrar</span>
                        </v-btn>
                        <v-btn
                            v-if="(allow_refresh || !emisor)"
                            color="primary_blue"
                            class="white--text action__btn"
                            :disabled="isParyIncoplete(actual_party)"
                            @click="saveParty()"
                        >
                            Guardar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            
            <v-dialog v-model="confirmSaveThird" class="pa-0 ma-0 rounded" width="350px">
                <v-card class="confirm__dialog text-center overflow-hidden">
                    <v-card-title>
                        <span class="px-1">Guardar tercero</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-6 px-12">
                        <v-row>
                            <v-col cols="12">
                                <v-icon size="48" color="primary_blue" class="material-symbols-outlined">warning</v-icon>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <span>¿Estás seguro de que deseas 
                                    <span v-if="actual_party && actual_party.id == -1">
                                        crear
                                    </span>
                                    <span v-else>
                                        actualizar
                                    </span>
                                    la ficha de este tercero?</span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-center pb-4">
                        <v-btn
                            outlined
                            @click="confirmSaveThird=false"
                            class="action__btn"
                            :disabled="savingParty"
                        >
                            Cancelar
                        </v-btn>
                        <v-btn 
                            color="primary_blue"
                            class="white--text action__btn"
                            :loading="savingParty"
                            :disabled="savingParty"
                            @click="confirmSaveParty()"
                        >
                            Guardar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </div> 
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DocTextField from "../components/DocTextField.vue"
import AppBtn from "@/components/layout/AppBtn.vue";
import AppSelect from "@/components/layout/AppSelect.vue";
import AppTextFieldV2 from "@/modules/widgets/infra/AppTextFieldV2.vue";
import AppDateField from "@/modules/widgets/infra/AppDateField.vue";
import PartyAutocomplete from "@/components/PartyAutocomplete.vue";
import { PAYMENT_MEANS_OPTIONS, RepresentationData } from "@/modules/facturae/domain/Invoiceable";
import { S3Repository } from '@/modules/shared/infra/S3Repository';
import awsconfig from '../aws-exports';
import { mapState } from "vuex";
import { SaveRepresentationModelCommand } from "@/modules/facturae/app/SaveRepresentationModelCommand";
import { SaveRepresentativeDNICommand } from "@/modules/facturae/app/SaveRepresentativeDNICommand";
import { SaveValidationFlagsCommand } from "@/modules/facturae/app/SaveValidationFlagsCommand";
import { sync_command_dispatcher, query_dispatcher_get, client, async_command_dispatcher } from "@/api/client";
import { GetCustomerDataQuery } from "@/modules/company/app/GetCustomerDataQuery";
import { DownloadRepresentationPdfQuery } from "@/modules/company/app/DownloadRepresentationPdfQuery";
import { DownloadUploadedRepresentationPdfQuery } from "@/modules/company/app/DownloadUploadedRepresentationPdfQuery";
import { DownloadUploadedDniQuery } from "@/modules/company/app/DownloadUploadedRepresentationDniQuery";
import ViesValidator from "./ViesValidator.vue";

export default {
    name: 'PartyEditor',

    components: {
        DocTextField,
        AppBtn,
        AppSelect,
        AppTextFieldV2,
        AppDateField,
        PartyAutocomplete,
        ViesValidator
    },

    props:{
        title: {
            type: String,
            required: true
        },
        party : {
            type: Object,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        },
        no_border: {
            type: Boolean,
            default: false
        },
        allow_refresh: {
            type: Boolean,
            default: false
        },
        emisor:{
            type: Boolean,
            required: true,
        },
        partyOptions: {
            type: Array,
            required: false,
            default: function () {
                return [];
            },
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        companyEditor: {
            type: Boolean,
            default: false
        },
        companydb_id: {
            type: Number,
            required: false
        },
        invoiceable_repo: {
            type: Object,
            required: false,
            default: null
        },
        company_id: {
            type: [Number, String],
            required: false,
            default: null
        },
        configuration: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        return {
            initial_party: null,
            uploadingFile: false,
            savingParty: false,
            creds: null,
            type_options: [
                {
                    text: "Persona jurídica",
                    value: "juridica"
                },
                {
                    text: "Persona física",
                    value: "fisica"
                }
            ],
            payment_means_options:  PAYMENT_MEANS_OPTIONS,
            language_options: [
                {
                    text: "Español",
                    value: "es"
                },
                {
                    text: "Inglés",
                    value: "en"
                },
                {
                    text: "Catalán",
                    value: "cat"
                }
            ],
            customer: this.party.clone(),
            tabs: [
                {code: "basic", "name": "Básicos"},
                {code: 'bank_info', "name": "Información bancaria"}
            ],
            activeTab: 'basic',
            showPartyEditor: false,
            confirmSaveThird: false,
            partyKey: 0,
            actual_party: this.party.clone(),
            tabsKey: 0,
            downloadingForm: false,
            downloadingUploadForm: false,
            validateDNI: false,
            validatePDF: false,
            rrsif_config: {
                'auto_send_to_verifactu': false,
                'sii_opt_checked': false,
                'spanish_territory_opt_checked': false,
                'no_application_checked': false,
                'switch_verification': false,
                'requestNoApplicationTextBox': undefined
            },
            checkboxDisabled: false,
            switchDisabled: false,
            textboxDisabled: false,
            verifactu_providers: [
                {id: 1, label: 'Zerocoma', value: "zerocoma"},
                {id: 3, label: 'Pyverifactu', value: "pyverifactu"}
            ],
            verifactu_provider: "",
            previousTextboxValue: '',
            hasStoredPreviousTextboxValue: false,
            activationDate: null,
            rrsifConfigLoaded: false,
            representationDataLoaded: false,
            configurationCache: null,
            uploadedPdfFileName: null,
            uploadedDniFileName: null
        }
    },
    mounted() {
        this.typeChanged()
        this.getCountriesList()
        if (this.emisor) {
            this.loadCompanyConfiguration()
        }
    },
    methods: {
        ...mapActions({
            getCountriesList: "countries/getCountries",
        }),
        validateCIF(value) {
            if (value) {
                const cleaned = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
                this.actual_party.cif = cleaned;
            }
        },
        typeChanged() {
            if (this.actual_party.type == 'juridica') {
                this.tabs = [
                    {code: "basic", "name": "Básicos"},
                    {code: 'bank_info', "name": "Información bancaria"},
                    {code: "dir3", "name": "DIR3"},
                    {code: 'datos_representacion', "name": "Datos de representación"},
                    {code: 'configuracion_rrsif', "name": "Configuración RRSIF"},
                    {code: 'advanced_config', "name": "Configuración Avanzada"}
                ]
            } else {
                this.tabs = [
                    {code: "basic", "name": "Básicos"},
                    {code: 'bank_info', "name": "Información bancaria"},
                    {code: 'configuracion_rrsif', "name": "Configuración RRSIF"},
                    {code: 'datos_representacion', "name": "Datos de representación"},
                    {code: 'advanced_config', "name": "Configuración Avanzada"}
                ]
            }
            this.tabsKey++
        },
        tabContains(tabCode) {
            return this.tabs.some(tab => tab.code === tabCode);
        },
        isParyIncoplete(party) {
            const isEmpty = (value) => ['', null, undefined].includes(value);
            const hasInvalidCharacters = (value) => {
                // Verifica si el valor contiene caracteres que no sean letras o números
                return value && /[^a-zA-Z0-9]/.test(value);
            };
            
            if (!party || (party && (isEmpty(party.cif) || hasInvalidCharacters(party.cif) || isEmpty(party.type) 
                        || (party.type == 'juridica' && isEmpty(party.business_name)) 
                        || (party.type == 'fisica' && (isEmpty(party.name) || isEmpty(party.first_surname)))
                        || isEmpty(party.address) || isEmpty(party.city) || isEmpty(party.province) || isEmpty(party.post_code)))) {
                return true
            }
            return false
        },
        async autocompleteEmit(party){
            if (!party) {
                this.customer = null;
                this.actual_party = this.party.clone();
                return;
            }
            
            await this.$emit('update_party', party)
            this.actual_party = party.clone();
            if (this.isParyIncoplete(party)){
                this.partyKey++
                if (!this.emisor) {
                    this.initial_party = party.clone();
                }
                this.showPartyEditor = true
            }
            this.typeChanged()
        },
        async openPartyEditor(){
            this.partyKey++

            this.showPartyEditor = true;
            if (this.emisor) {
                this.loadCompanyConfiguration().then(() => {
                    this.initial_party = this.actual_party.clone();
                });
            } else {
                this.initial_party = this.actual_party.clone();
            }
        },
        cancelSave(){
            if (this.emisor && this.allow_refresh) {
                this.actual_party = this.initial_party.clone();
            }
            if (!this.emisor) {
                this.customer = this.actual_party 
            }
            this.showPartyEditor = false
        },
        async saveParty(){
            // Actualizar los valores de validación en el party antes de guardar
            this.actual_party.is_dni_validated = this.validateDNI;
            this.actual_party.is_representation_pdf_validated = this.validatePDF;

            if (!this.emisor && this.got_feature('feature_dont_override_customers')) {
                this.actual_party.timestamp_modified = new Date().toISOString();
            }

            if (this.emisor) {
                // Asegurar que rrsif_config tenga los valores actualizados de los checkboxes
                this.rrsif_config['is_dni_validated'] = this.validateDNI;
                this.rrsif_config['is_representation_pdf_validated'] = this.validatePDF;

                // Guardar toda la configuración incluyendo RRSIF y los checkboxes de validación
                try {
                    await this.saveRRSIFConfig();
                } catch (error) {
                    console.error('[PartyEditor] Error al guardar configuración RRSIF:', error);
                    this.$emit('error-message', 'Error al guardar la configuración RRSIF');
                    return;
                }

                // Call the parent and wait for the result
                const handlers = this.$listeners.save_company_as_party;
                let success = true; // Default to true for backward compatibility

                if (handlers) {
                    if (Array.isArray(handlers)) {
                        success = await handlers[0](this.actual_party);
                    } else {
                        success = await handlers(this.actual_party);
                    }
                }

                // Only close the dialog if it was successful (or if there was no handler)
                if (success) {
                    // Also emit the validation values to synchronize with ConnectorDetailV2
                    this.$emit('validation_flags_updated', {
                        is_dni_validated: this.validateDNI,
                        is_representation_pdf_validated: this.validatePDF
                    })
                    this.showPartyEditor = false
                    this.$emit('success-message', 'Datos guardados correctamente');
                }
            }
            else {
                this.confirmSaveThird = true
            }
        },
        async confirmSaveParty() {
            // Evitar múltiples clicks mientras se guarda
            if (this.savingParty) {
                return;
            }

            this.savingParty = true;
            try {
                // Call the parent and wait for the result
                const handlers = this.$listeners.saveThird;
                let success = true; // Default to true for backward compatibility

                if (handlers) {
                    // If there is a handler, call it and wait for the result
                    if (Array.isArray(handlers)) {
                        success = await handlers[0](this.actual_party);
                    } else {
                        success = await handlers(this.actual_party);
                    }
                }
                // Only close the dialog if it was successful (or if there was no handler)
                if (success) {
                    this.customer = this.actual_party;
                    this.confirmSaveThird = false;
                    this.showPartyEditor = false;
                }
            } finally {
                this.savingParty = false;
            }
        },
        async companyEditorClose(){
            await this.$emit('companyEditorClose', this.actual_party)
            // Emitir también los valores de validación para que ConnectorDetailV2 los sincronice
            this.$emit('validation_flags_updated', {
                is_dni_validated: this.validateDNI,
                is_representation_pdf_validated: this.validatePDF
            })
            this.showPartyEditor = false
        },
        async loadRepresentationDataFromCompany(){
            try {
                const effectiveCompanyId = this.companydb_id || this.company_id;
                if (!effectiveCompanyId) return;

                // Obtener la configuración de la empresa
                const currentData = await client.get('companydbs_detail/' + effectiveCompanyId + '/');

                if (currentData.data.configuration) {
                    // Cargar los flags de validación
                    this.validateDNI = currentData.data.configuration.is_dni_validated || false;
                    this.validatePDF = currentData.data.configuration.is_representation_pdf_validated || false;

                    // Si hay datos de representación guardados, cargarlos y convertirlos a instancia de RepresentationData
                    if (currentData.data.configuration.company_as_party) {
                        const cap = currentData.data.configuration.company_as_party;
                        if (cap.representation_data) {
                            this.actual_party.representation_data = RepresentationData.fromPrimitive(cap.representation_data);
                        }
                    }
                }

                await this.checkUploadedFiles(effectiveCompanyId);
            } catch (e) {
                console.error('[PartyEditor] Error al cargar datos de representación:', e);
            }
        },
        async checkUploadedFiles(companyId) {
            try {
                const user_id = this.$store.getters['me/userData'].id;

                // Ejecutar ambas consultas en paralelo para mejor rendimiento
                const [pdfResult, dniResult] = await Promise.allSettled([
                    new DownloadUploadedRepresentationPdfQuery(query_dispatcher_get)
                        .run({ user_id, company_id: companyId })
                        .catch(() => null),
                    // Verificar DNI
                    new DownloadUploadedDniQuery(query_dispatcher_get)
                        .run({ user_id, company_id: companyId })
                        .catch(() => null)
                ]);

                if (pdfResult.status === 'fulfilled' && pdfResult.value && pdfResult.value.url) {
                    const urlParts = pdfResult.value.url.split('/');
                    const fileNameWithParams = urlParts[urlParts.length - 1];
                    this.uploadedPdfFileName = fileNameWithParams.split('?')[0];
                }
                if (dniResult.status === 'fulfilled' && dniResult.value && dniResult.value.url) {
                    const urlParts = dniResult.value.url.split('/');
                    const fileNameWithParams = urlParts[urlParts.length - 1];
                    this.uploadedDniFileName = fileNameWithParams.split('?')[0];
                }
            } catch (e) {
                console.error('[PartyEditor] Error al verificar archivos subidos:', e);
            }
        },
        async saveRepresentationData(){
            try {
                const effectiveCompanyId = this.companydb_id || this.company_id;
                // Primero obtenemos la configuración actual para no sobrescribirla
                const currentData = await client.get('companydbs_detail/' + effectiveCompanyId + '/');
                // Actualizamos solo company_as_party dentro de configuration
                const updatedConfiguration = {
                    ...currentData.data.configuration,
                    company_as_party: this.actual_party.toPrimitive(this.actual_party)
                };
                // El serializer requiere json_links con solo los campos necesarios
                const links = (currentData.data.links || []).map(link => ({
                    id: link.id,
                    link_path: link.link_path,
                    link_name: link.link_name,
                    min_date: link.min_date,
                    max_date: link.max_date,
                    start_ejercicio: link.start_ejercicio,
                    end_ejercicio: link.end_ejercicio,
                    year_ejercicio: link.year_ejercicio,
                    companydb: link.companydb,
                    active: link.active,
                    prorate_percent: link.prorate_percent,
                    validation_state: link.validation_state,
                    deleted: false
                }));

                const params = {
                    configuration: updatedConfiguration,
                    json_links: JSON.stringify(links),
                    companydb_type_id: currentData.data.companydb_type.id
                };

                await client.patch('companydbs_detail/' + effectiveCompanyId + '/', params);

                // Actualizar el party original con los datos de representación guardados
                this.party.representation_data = this.actual_party.representation_data;

                if (this.companyEditor) {
                    this.$emit('companyEditorClose', this.actual_party);
                }

                this.$emit('success-message', 'Datos de representación guardados correctamente');
            } catch (e) {
                console.error('[PartyEditor] Error al guardar datos de representación:', e);
                this.$emit('error-message', 'Error al guardar datos de representación: ' + (e.message || 'Error desconocido'));
            }
        },
        
        filterItems(item, queryText) {
            if (item.type == 'fisica') {
                return (
                    item.first_surname.toLowerCase().includes(queryText.toLowerCase()) ||
                    item.second_surname.toLowerCase().includes(queryText.toLowerCase())||
                    item.name.toLowerCase().includes(queryText.toLowerCase())||
                    (item.debit_account && item.debit_account.toLowerCase().includes(queryText.toLowerCase()))
                );
            } else {
                return (
                    item.business_name.toLowerCase().includes(queryText.toLowerCase())||
                    (item.debit_account && item.debit_account.toLowerCase().includes(queryText.toLowerCase()))
                );
            }
        },
        checkDownloadRepresentationForm() {
            if (this.actual_party.type === 'juridica' && !this.isRepresentationDataComplete) {
                this.$emit('error-message', 'Faltan datos por rellenar para poder descargar el modelo');
                return;
            }
            this.downloadRepresentationForm();
        },
        async downloadRepresentationForm() {
            this.downloadingForm = true;
            try {
                const effectiveCompanyId = this.companydb_id || this.company_id;

                if (!effectiveCompanyId) {
                    throw new Error('No se encontró el ID de la empresa. Por favor, recarga la página.');
                }
                const downloadQuery = new DownloadRepresentationPdfQuery(query_dispatcher_get);
                const user_id = this.$store.getters['me/userData'].id;
                const result = await downloadQuery.run({
                    user_id: user_id,
                    company_id: effectiveCompanyId
                });

                if (!result.content) {
                    throw new Error('No se pudo obtener el contenido del PDF');
                }

                // Decodificar el contenido base64 a binario
                const binaryString = atob(result.content);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }

                const blob = new Blob([bytes], { type: 'application/pdf' });

                // Crear URL y descargar
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `otorgamiento_representacion.pdf`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);

                this.$emit('success-message', 'Formulario de representación generado correctamente');
            } catch (e) {
                console.error('[PartyEditor] Error al generar el formulario:', e);
                this.$emit('error-message', 'Error al generar el formulario: ' + e.message);
            } finally {
                this.downloadingForm = false;
            }
        },

        async downloadUploatedRepresentationForm() {
            this.downloadingUploadForm = true;
            try {
                const effectiveCompanyId = this.companydb_id || this.company_id;

                if (!effectiveCompanyId) {
                    throw new Error('No se encontró el ID de la empresa. Por favor, recarga la página.');
                }

                // Crear y ejecutar la query
                const downloadQuery = new DownloadUploadedRepresentationPdfQuery(query_dispatcher_get);
                const user_id = this.$store.getters['me/userData'].id;

                const result = await downloadQuery.run({
                    user_id: user_id,
                    company_id: effectiveCompanyId
                });

                if (!result.url) {
                    throw new Error(result.error || 'No se ha subido ningún formulario de representación');
                }

                const link = document.createElement("a");
                link.href = result.url;
                link.download = `formulario_representacion_subido.pdf`;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.$emit('success-message', 'Formulario descargado correctamente');
            } catch (e) {
                console.error('[PartyEditor] Error al descargar el formulario:', e);
                this.$emit('error-message', 'Error al descargar el formulario: ' + e.message);
            } finally {
                this.downloadingUploadForm = false;
            }
        },
        async downloadUploatedDni() {
            this.downloadingUploadForm = true;
            try {
                const effectiveCompanyId = this.companydb_id || this.company_id;

                if (!effectiveCompanyId) {
                    throw new Error('No se encontró el ID de la empresa. Por favor, recarga la página.');
                }

                // Crear y ejecutar la query
                const downloadQuery = new DownloadUploadedDniQuery(query_dispatcher_get);
                const user_id = this.$store.getters['me/userData'].id;

                const result = await downloadQuery.run({
                    user_id: user_id,
                    company_id: effectiveCompanyId
                });

                if (!result.url) {
                    throw new Error(result.error || 'No se ha subido ningún DNI');
                }

                const link = document.createElement("a");
                link.href = result.url;
                link.download = `formulario_representacion_subido.pdf`;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.$emit('success-message', 'Formulario descargado correctamente');
            } catch (e) {
                console.error('[PartyEditor] Error al descargar el formulario:', e);
                this.$emit('error-message', 'Error al descargar el formulario: ' + e.message);
            } finally {
                this.downloadingUploadForm = false;
            }
        },
        async prepareReportData() {
            // Obtener la fecha actual para las firmas
            const today = new Date();
            const day = today.getDate().toString();
            const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
                           'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
            const month = months[today.getMonth()];
            const year = today.getFullYear().toString();
            const party = this.actual_party;
            const municipio = party.city || '';
            const via = party.address || '';
            const numero = '';

            // Obtener datos del cliente desde el backend
            const customerQuery = new GetCustomerDataQuery(query_dispatcher_get);
            const user_id = this.$store.getters['me/userData'].id;
            const customerData = await customerQuery.run({
                user_id: user_id,
                company_id: this.companydb_id || this.company_id
            });
            
            


            let reportData = {
                provider: {
                    name: customerData.name,
                    nif: customerData.nif
                },
                grantorSign: {
                    place: municipio,
                    day: day,
                    month: month,
                    year: year
                },
                providerSign: {
                    place: customerData.city || '',
                    day: day,
                    month: month,
                    year: year
                }
            };

            if (party.type === 'fisica') {
                reportData.grantor = {
                    name: `${party.name} ${party.first_surname} ${party.second_surname || ''}`.trim(),
                    nif: party.cif,
                    municipio: municipio,
                    via: via,
                    numero: numero
                };
            } else {
                reportData.entity = {
                    name: party.business_name || '',
                    nif: party.cif,
                    municipio: municipio,
                    via: via,
                    numero: numero,
                    representativeName: customerData.name || '',
                    representativeNif: customerData.nif || '',
                    representativeRole: 'representante legal',
                    representativeMunicipio: customerData.city || '',
                    representativeVia: customerData.street || '',
                    representativeNumero: customerData.number || ''
                };
            }

            console.log('reportData =>:: ', reportData)
            return reportData;
        },
        openFileExplorerPDF() {
            this.$refs.fileInputPDF.click()
        },
        openFileExplorerDNI() {
            this.$refs.fileInputDNI.click()
        },
        setupAWSCredentials(sessionInfo = null) {
            const session = sessionInfo || this.$store.state.session_information;

            if (!session || !session.signInUserSession) {
                throw new Error('Sesión no disponible. Por favor, recarga la página.');
            }

            this.creds = new AWS.CognitoIdentityCredentials({
                IdentityPoolId: awsconfig['aws_cognito_identity_pool_id'],
            });
            this.creds.params = this.creds.params || {};
            this.creds.params.Logins = this.creds.params.Logins || {};
            this.creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] =
                session.signInUserSession.idToken.jwtToken;
            this.creds.expired = true;
            AWS.config.update({
                region: awsconfig['aws_user_files_s3_bucket_region'],
                credentials: this.creds,
            });
        },
        async handleFileUpload(event, file_kind) {
            const file = event.target.files[0];
            if (!file) return;
            if (file_kind !== 'pdf' && file_kind !== 'dni') {
                console.error("file_kind must be 'pdf' or 'dni' - file_kind:", file_kind)
                return
            }
            const fileName = file.name
            try {
                const imageFileExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
                this.uploadingFile = true;
                if (file_kind === 'pdf' && file.type !== 'application/pdf') {
                    this.$emit('error-message', 'Por favor, sube un archivo PDF');
                    return;
                }
                else if (file_kind === 'dni' && file.type !== 'application/pdf') {
                    const okExtension = imageFileExtensions.some(ext => fileName.toLowerCase().endsWith('.' + ext))
                    if (!okExtension) {
                        this.$emit('error-message', 'Por favor, sube un PDF o imagen (Extensiones soportadas: ' + imageFileExtensions.join(', ') + ')')
                        return
                    }
                }
                // file type/extension are both OK
                
                const sessionInfo = this.$store.state.session_information;
                this.setupAWSCredentials(sessionInfo);
                
                const s3_repo = new S3Repository(AWS, 'client_forms');
                const s3_path = await s3_repo.uploadFile(file);
                if (file_kind === 'pdf') {
                    const cmd = new SaveRepresentationModelCommand(sync_command_dispatcher, this);
                    const commandData = {pdf_representation_url: s3_path, company_id: this.companydb_id || this.company_id};
                    let res = await cmd.run(commandData, null);
                    if (res === true) {
                        this.uploadedPdfFileName = fileName;
                        this.$emit('success-message', 'Formulario subido correctamente')
                    }
                    else throw Error("Se ha producido un error al guardar el documento")
                }
                else {
                    const cmd = new SaveRepresentativeDNICommand(this)
                    let res = await cmd.run(s3_path, fileName, this.companydb_id || this.company_id)
                    if (res === true) {
                        this.uploadedDniFileName = fileName;
                        this.$emit('success-message', 'DNI subido correctamente')
                    }
                    else throw Error("Se ha producido un error al guardar el documento")
                }
            } catch (error) {
                let consoleMsg = file_kind == 'pdf' ? 'Error al subir el formulario: ' : 'Error al subir el DNI: '
                console.error(consoleMsg, error)
                this.$emit('error-message', consoleMsg + error.message)
            } finally {
                this.uploadingFile = false;
            }
        },
        onlyOneSelectedRRSIFOption(key) {
            const keys = [
                'auto_send_to_verifactu',
                'sii_opt_checked',
                'spanish_territory_opt_checked',
                'no_application_checked'
            ];
            for(let k of keys){
                if (k !== key){
                    this.rrsif_config = {...this.rrsif_config, [k]: false}
                }
            }

            let isSwitchTrue = this.rrsif_config['switch_verification'] = false
            let isCheckBoxSIIChecked = this.rrsif_config['sii_opt_checked']
            let isCheckBoxESPTerritoryChecked = this.rrsif_config['spanish_territory_opt_checked']
            let isCheckBoxNoApplChecked = this.rrsif_config['no_application_checked']
            let isCheckBoxVerifactuChecked = this.rrsif_config['auto_send_to_verifactu'];
            let isTextboxFilled = this.rrsif_config['requestNoApplicationTextBox']
            this.switchDisabledConfig(isSwitchTrue, isCheckBoxSIIChecked, isCheckBoxESPTerritoryChecked, isCheckBoxNoApplChecked)
            this.noApplicTextboxDisabledConfig(isCheckBoxVerifactuChecked, isCheckBoxSIIChecked, isCheckBoxESPTerritoryChecked, isCheckBoxNoApplChecked, isTextboxFilled)
        },
        noApplicTextboxDisabledConfig(isCheckBoxVerifactuChecked, isCheckBoxSIIChecked, isCheckBoxESPTerritoryChecked, isCheckBoxNoApplChecked, isTextboxFilled) {
            const shouldDisableTextbox = isCheckBoxVerifactuChecked || isCheckBoxSIIChecked || isCheckBoxESPTerritoryChecked || isTextboxFilled;

            if (isCheckBoxNoApplChecked) {
                this.textboxDisabled = false;
                if (!this.rrsif_config['requestNoApplicationTextBox'] && this.hasStoredPreviousTextboxValue) {
                    this.rrsif_config['requestNoApplicationTextBox'] = this.previousTextboxValue;
                }
                this.hasStoredPreviousTextboxValue = false;
            }

            if (shouldDisableTextbox) {
                if (!this.hasStoredPreviousTextboxValue) {
                    this.previousTextboxValue = this.rrsif_config['requestNoApplicationTextBox'] || '';
                    this.hasStoredPreviousTextboxValue = true;
                }

                this.textboxDisabled = true;
                this.rrsif_config['requestNoApplicationTextBox'] = '';
            }
        },
        switchDisabledConfig(isSwitchTrue, isCheckBoxSIIChecked, isCheckBoxESPTerritoryChecked, isCheckBoxNoApplChecked) {
            if (!isSwitchTrue){
                this.switchDisabled = true
            }
            if (isCheckBoxSIIChecked || isCheckBoxESPTerritoryChecked || isCheckBoxNoApplChecked) {
                this.switchDisabled = false
            }
        },
        async loadCompanyConfiguration() {
            try {
                const effectiveCompanyId = this.companydb_id || this.company_id;
                if (!effectiveCompanyId) return;

                const currentData = await client.get('companydbs_detail/' + effectiveCompanyId + '/');
                const config = currentData.data.configuration;

                if (!config) return;

                this.configurationCache = config;
                this.rrsif_config = {
                    'auto_send_to_verifactu': config.auto_send_to_verifactu || false,
                    'sii_opt_checked': config.sii_opt_checked || false,
                    'spanish_territory_opt_checked': config.spanish_territory_opt_checked || false,
                    'no_application_checked': config.no_application_checked || false,
                    'switch_verification': config.switch_verification || false,
                    'requestNoApplicationTextBox': config.requestNoApplicationTextBox || undefined
                };

                if (config.activationDate) {
                    this.activationDate = config.activationDate;
                }

                // Cargar flags de validación (para checkboxes y para rrsif_config)
                this.validateDNI = config.is_dni_validated || false;
                this.validatePDF = config.is_representation_pdf_validated || false;

                // También guardarlos en rrsif_config para mantener coherencia con ConnectorDetailV2
                this.rrsif_config['is_dni_validated'] = config.is_dni_validated || false;
                this.rrsif_config['is_representation_pdf_validated'] = config.is_representation_pdf_validated || false;

                if (config.company_as_party && config.company_as_party.representation_data) {
                    this.actual_party.representation_data = RepresentationData.fromPrimitive(
                        config.company_as_party.representation_data
                    );
                }

                try {
                    const settingPayload = { setting_code: 'verifactu_provider' };
                    const settingResult = await query_dispatcher_get.dispatch("get.setting", settingPayload);
                    if (settingResult && settingResult.provider) {
                        this.verifactu_provider = settingResult.provider;
                    }
                } catch (e) {
                    console.log('[PartyEditor] No se encontró configuración de verifactu_provider');
                }

                this.applyDisabledFromLoadedConfig();
                this.rrsifConfigLoaded = true;
                this.representationDataLoaded = true;

                // Verificar archivos subidos (PDF de representación y DNI)
                await this.checkUploadedFiles(effectiveCompanyId);

            } catch (e) {
                console.error('[PartyEditor] Error al cargar configuración de la empresa:', e);
            }
        },
        async loadRRSIFConfig(force = false) {
            if (this.rrsifConfigLoaded && !force) return;

            try {
                const effectiveCompanyId = this.companydb_id || this.company_id;
                if (!effectiveCompanyId) return;

                const currentData = await client.get('companydbs_detail/' + effectiveCompanyId + '/');

                if (currentData.data.configuration) {
                    const config = currentData.data.configuration;

                    // Cargar campos individuales de RRSIF desde configuration (mismo formato que ConnectorDetailV2)
                    this.rrsif_config = {
                        'auto_send_to_verifactu': config.auto_send_to_verifactu || false,
                        'sii_opt_checked': config.sii_opt_checked || false,
                        'spanish_territory_opt_checked': config.spanish_territory_opt_checked || false,
                        'no_application_checked': config.no_application_checked || false,
                        'switch_verification': config.switch_verification || false,
                        'requestNoApplicationTextBox': config.requestNoApplicationTextBox || undefined
                    };

                    // Cargar fecha de activación
                    if (config.activationDate) {
                        this.activationDate = config.activationDate;
                    }

                    // Cargar proveedor de verifactu desde settings
                    try {
                        const settingPayload = { setting_code: 'verifactu_provider' };
                        const settingResult = await query_dispatcher_get.dispatch("get.setting", settingPayload);
                        if (settingResult && settingResult.provider) {
                            this.verifactu_provider = settingResult.provider;
                        }
                    } catch (e) {
                        console.log('[PartyEditor] No se encontró configuración de verifactu_provider');
                    }
                    this.applyDisabledFromLoadedConfig();
                    this.rrsifConfigLoaded = true;
                }
            } catch (e) {
                console.error('[PartyEditor] Error al cargar configuración RRSIF:', e);
            }
        },
        async saveRRSIFConfig() {
            try {
                const effectiveCompanyId = this.companydb_id || this.company_id;
                const currentData = await client.get('companydbs_detail/' + effectiveCompanyId + '/');

                try {
                    const payload = {
                        setting_code: "verifactu_provider",
                        payload: {"provider": this.verifactu_provider},
                        setting_company_id: effectiveCompanyId,
                    };
                    await query_dispatcher_get.dispatch("set.setting", payload);
                } catch (e) {
                    console.error('[PartyEditor] Error al guardar verifactu_provider:', e);
                }

                const isCheckBoxVerifactuChecked = this.rrsif_config['auto_send_to_verifactu'];
                if (isCheckBoxVerifactuChecked) {
                    if (!currentData.data.configuration['activationDate']) {
                        this.activationDate = this.getActualDate();
                    }
                } else {
                    this.activationDate = '';
                }

                const updatedConfiguration = {
                    ...currentData.data.configuration,
                    'auto_send_to_verifactu': this.rrsif_config['auto_send_to_verifactu'],
                    'sii_opt_checked': this.rrsif_config['sii_opt_checked'],
                    'spanish_territory_opt_checked': this.rrsif_config['spanish_territory_opt_checked'],
                    'no_application_checked': this.rrsif_config['no_application_checked'],
                    'switch_verification': this.rrsif_config['switch_verification'],
                    'requestNoApplicationTextBox': this.rrsif_config['requestNoApplicationTextBox'],
                    'activationDate': this.activationDate,
                    'is_dni_validated': this.rrsif_config['is_dni_validated'],
                    'is_representation_pdf_validated': this.rrsif_config['is_representation_pdf_validated']
                };

                const links = (currentData.data.links || []).map(link => ({
                    id: link.id,
                    link_path: link.link_path,
                    link_name: link.link_name,
                    min_date: link.min_date,
                    max_date: link.max_date,
                    start_ejercicio: link.start_ejercicio,
                    end_ejercicio: link.end_ejercicio,
                    year_ejercicio: link.year_ejercicio,
                    companydb: link.companydb,
                    active: link.active,
                    prorate_percent: link.prorate_percent,
                    validation_state: link.validation_state,
                    deleted: false
                }));

                const params = {
                    configuration: updatedConfiguration,
                    json_links: JSON.stringify(links),
                    companydb_type_id: currentData.data.companydb_type.id
                };

                await client.patch('companydbs_detail/' + effectiveCompanyId + '/', params);
            } catch (e) {
                console.error('[PartyEditor] Error al guardar configuración RRSIF:', e);
                throw e;
            }
        },
        getActualDate() {
            const today = new Date();
            const day = String(today.getDate()).padStart(2, '0');
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const year = today.getFullYear();
            return `${day}/${month}/${year}`;
        },
        applyDisabledFromLoadedConfig() {
            const isCheckBoxVerifactuChecked = this.rrsif_config['auto_send_to_verifactu'];
            const isCheckBoxNoApplChecked = this.rrsif_config['no_application_checked'];
            const isCheckBoxSIIChecked = this.rrsif_config['sii_opt_checked'];
            const isCheckBoxESPTerritoryChecked = this.rrsif_config['spanish_territory_opt_checked'];

            if (isCheckBoxVerifactuChecked) {
                this.checkboxDisabled = true;
                this.switchDisabled = true;
            }

            if (isCheckBoxNoApplChecked && !this.rrsif_config['switch_verification']) {
                this.switchDisabled = false;
            }

            if (isCheckBoxSIIChecked || isCheckBoxESPTerritoryChecked) {
                this.switchDisabled = false;
            }

            if (!isCheckBoxNoApplChecked) {
                this.textboxDisabled = true;
            } else {
                this.textboxDisabled = false;
            }
        },
    },
    computed: {
        ...mapGetters(['is_mobile', 'got_feature']),
        ...mapGetters('me', ['userData']),
        ...mapGetters('countries', ['getCountries', 'getCountryByCode']),
        ...mapState(['session_information']),
        country_options() {
            return this.getCountries.map((country_code) => {
                let country = this.getCountryByCode(country_code);
                return {"text": country.name, "value": country.code}
            });
        },
        cols_first_sector(){
            if(!this.emisor && this.actual_party.type == 'juridica'){
                return 7
            }
            else{
                return 12
            }
        },
        isRepresentationDataComplete() {
            const data = this.actual_party.representation_data;
            if (!data) return false;

            // Pestaña 'Datos de Representación'
            const hasClientName = data.client_name && data.client_name.trim() !== '';
            const hasClientNif = data.client_nif && data.client_nif.trim() !== '';
            const hasMunicipality = data.municipality && data.municipality.trim() !== '';
            const hasStreet = data.street && data.street.trim() !== '';
            const hasNumber = data.number && data.number.trim() !== '';

            // Pestaña 'Básicos'
            const hasRazonSocial = this.actual_party.business_name && this.actual_party.business_name.trim() !== '';
            const hasNombreComercial = this.actual_party.trade_name && this.actual_party.trade_name.trim() !== '';
            const hasAddress = this.actual_party.address && this.actual_party.address.trim() !== '';

            return hasClientName && hasClientNif && hasMunicipality && hasStreet && hasNumber &&
                   hasRazonSocial && hasNombreComercial && hasAddress;
        },
        isInRepresentationTab() {
            let tabIndex = 0;
            tabIndex++;
            if (this.tabContains('bank_info')) tabIndex++;
            if (this.actual_party.type == 'juridica' && !this.emisor && this.tabContains('dir3')) tabIndex++;

            return this.tabContains('datos_representacion') && this.activeTab === tabIndex;
        },

        ifPersonaFisicaReadOnly() {
            return this.actual_party.type == 'fisica';
        },

        representativeFullName() {
            if (this.actual_party.type !== 'fisica') {
                return (this.actual_party.representation_data && this.actual_party.representation_data.client_name) || '';
            }

            // Para persona física, concatenar nombre + apellidos
            const parts = [
                this.actual_party.name,
                this.actual_party.first_surname,
                this.actual_party.second_surname
            ].filter(part => part && part.trim() !== '');

            return parts.join(' ');
        },

        representativeNif() {
            if (this.actual_party.type !== 'fisica') {
                return (this.actual_party.representation_data && this.actual_party.representation_data.client_nif) || '';
            }

            // Para persona física, usar el CIF
            return this.actual_party.cif || '';
        },

        representativeMunicipality() {
            if (this.actual_party.type !== 'fisica') {
                return (this.actual_party.representation_data && this.actual_party.representation_data.municipality) || '';
            }

            // Para persona física, usar la localidad de la pestaña Básicos
            return this.actual_party.city || '';
        },

        representativeStreet() {
            if (this.actual_party.type !== 'fisica') {
                return (this.actual_party.representation_data && this.actual_party.representation_data.street) || '';
            }

            // Para persona física, usar la dirección de la pestaña Básicos
            return this.actual_party.address || '';
        },


        im_staff_or_login_as() {
            if (!this.userData) return false;

            // Si es staff, mostrar los checkboxes
            if (this.userData.is_staff) return true;

            // Si está en modo "login as" (usernames diferentes), mostrar los checkboxes
            if (this.session_information &&
                this.session_information.hasOwnProperty('username') &&
                this.userData.hasOwnProperty('username') &&
                this.session_information.username !== this.userData.username) {
                return true;
            }

            return false;
        },
        showRRSIFTab() {
            if (!this.userData || !this.userData.can_view_e_invoice) {
                return false;
            }
            if (this.im_staff_or_login_as) {
                return true;
            }

            let is_dni_validated = this.rrsif_config && this.rrsif_config['is_dni_validated'] === true;
            let is_pdf_validated = this.rrsif_config && this.rrsif_config['is_representation_pdf_validated'] === true;
            let documents_validated = is_dni_validated && is_pdf_validated;

            return documents_validated;
        },
        hasEInvoiceContract() {
            return this.emisor;
        },
        tradeNameModel: {
            get() {
                // Display alias if available, otherwise display actual trade_name
                if (this.emisor && this.configuration && this.configuration.alias && this.configuration.alias.trim()) {
                    return this.configuration.alias;
                }
                return this.actual_party && this.actual_party.trade_name ? this.actual_party.trade_name : '';
            },
            set(value) {
                // Always update actual_party.trade_name when user edits
                // The alias is managed separately in the configuration
                if (this.actual_party) {
                    this.actual_party.trade_name = value;
                }
            }
        },
        isTradeNameReadonly() {
            // Make field readonly if using alias from sequence/configuration
            if (this.emisor && this.configuration && this.configuration.alias && this.configuration.alias.trim()) {
                return true;
            }
            // Otherwise use the readonly prop from parent
            return this.readonly;
        }
    },
    watch: {
        party: {
            handler(newVal) {
                if (newVal) {
                    this.customer = newVal.clone();
                    this.actual_party = newVal.clone();
                }
            },
            deep: true,
            immediate: true
        },
        configuration: {
            handler() {
                // Force re-render when configuration changes
                if (this.emisor) {
                    this.$forceUpdate();
                }
            },
            deep: true,
            immediate: false
        },
        'configuration.alias': {
            handler() {
                if (this.emisor) {
                    this.$forceUpdate();
                }
            },
            immediate: false
        },
        validateDNI(newVal) {
            this.rrsif_config['is_dni_validated'] = newVal;
        },
        validatePDF(newVal) {
            this.rrsif_config['is_representation_pdf_validated'] = newVal;
        }
    }
}
</script>

<style scoped>
    .input-label {
        font-size: 12px !important;
    }

    /* Estilos para el selector de Verifactu */
    .verifactu-select {
        min-width: 150px;
        max-width: 200px;
        flex-shrink: 0;
    }

    /* Asegurar que el app-select tenga suficiente espacio */
    .verifactu-select >>> .v-input__control {
        min-width: 150px;
    }

    .verifactu-select >>> .v-select__selections {
        flex-wrap: nowrap;
        overflow: visible;
    }

    .edit__btn {
        border-radius:2px !important;
        border: 0.5px solid var(--v-primary-base) !important;
    }

    .edit__btn span {
        font-size: 12px;
        font-weight: 500;
        font-family: "Roboto";
        line-height: 14px;
        text-transform: capitalize;
    }

    .party__editor__title {
        background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
        height: 70px;
    }

    .party__editor__title span {
        font-size: 20px;
        font-weight: 600;
        font-family: "Roboto";
        line-height: 24px;
        text-transform: capitalize;
        color: var(--v-primary_blue-base);
    }

    .card__tabs .v-tab.v-tab, .card__tabs >>> .v-tabs-slider  {
    color: var(--v-primary_blue-base) !important;
    }

    .complete__btn {
        font-weight: 700;
        font-size: 13px;
        line-height: 15px;
    }

    .action__btn {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        border-radius: 20px;
        padding: 18px !important;
        gap: 8px;
        text-transform: capitalize;
    }

    .error--text {
        color: rgba(220, 11, 11, 0.898) !important;
    }

    .confirm__dialog .v-card__title {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
        background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white) !important;
        color: var(--v-primary_blue-base) !important;
        font-family: 'Roboto', sans-serif !important;
        font-weight: 600 !important;
        font-size: 20px !important;
        line-height: 24px !important;
    }

    .label-base {
        font-size: 14px !important;  
    }

    .button-nou {
        border-radius: 10px;
        border: 1px solid var(--Primary-800, var(--v-primary-base));
        background: var(--Primary-50, color-mix(in srgb, var(--v-primaryLight-base) 20%, white));
        display: flex;
        width: auto;
        height: 24px;
        padding: 2px 2px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;
        color: var(--Primary-800, var(--v-primary-base)) !important;
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .button-nou--icon-only {
        min-width: unset !important;
        width: 24px !important;
        padding: 0 !important;
    }

    .label-cif {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
    }
</style>